import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeService } from 'src/app/POS/POSServices/Employees/employee.service';
import { CommonFunctionService } from 'src/app/services/Common/common-function.service';
import { SessionTimeoutService } from 'src/app/services/session-timeout.service';

const _clone = (d) => JSON.parse(JSON.stringify(d));
@Component({
  selector: 'app-ac-sidebar',
  templateUrl: './ac-sidebar.component.html',
  styleUrls: ['./ac-sidebar.component.scss'],
})
export class AcSidebarComponent implements OnInit {
  PaygsetUphideshow: boolean = true;
  MerchantKeyId: any;
  resellerno: any;
  rows = [];
  constructor(
    private router: Router,
    private service: EmployeeService,
    private commonfunction: CommonFunctionService,
    private sessionTimeoutService: SessionTimeoutService
  ) {}

  ngOnInit() {
    this.sessionTimeoutService.startSessionTimeout();
    this.MenuSetup();
  }
  navigateToLogin() {
    localStorage.removeItem('VirtualPOSToken'); 
    localStorage.removeItem('logodetails');
    localStorage.removeItem('logoimagepath');
    localStorage.removeItem('Merchantinfoes');
    localStorage.removeItem('Status');
    localStorage.removeItem("WhitelabelContent");
    localStorage.removeItem("ResellerEmail");
    localStorage.removeItem("ResellerPhoneNumber");
    localStorage.removeItem("ResellerName"); 
    this.router.navigate(['/login']);
  }

  MenuSetup() {
    this.MerchantKeyId =
      this.commonfunction.getUserMerchantData().MerchantKeyId;
    this.resellerno = this.commonfunction.getUserMerchantData().ResellerId;
    this.service
      .getMerchantServicesAndFees(this.MerchantKeyId, this.resellerno)
      .subscribe((result) => {
        if (result != null) {
          this.rows = _clone(result);
          this.rows.forEach((element) => {
            if (element.ServiceCode == 'PayGSetUp' && element.Status == 1) {
              this.PaygsetUphideshow = true;
            }

            if (element.ServiceCode == 'PayGSetUp' && element.Status == 0) {
              this.PaygsetUphideshow = false;
            }
          });
        }
      });
  }
}
